import classNames from 'classnames'

import './Button.scss'

type ButtonVariant =
  | 'primary'
  | 'secondary'
  | 'accent'
  | 'transparent'
  | 'iconBtn'
  | 'danger'
  | 'iconDangerBtn'
  | 'textOnly'
  | 'textOnlyDanger'
  | 'textOnlyLink'

interface ButtonProps {
  id?: string
  variant?: ButtonVariant
  className?: string
  styles?: React.CSSProperties
  submit?: boolean
  disabled?: boolean
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  children: React.ReactNode
  fullWidth?: boolean
  small?: boolean
}

function Button({
  id,
  variant = 'secondary',
  className,
  styles,
  submit,
  disabled,
  onClick,
  children,
  fullWidth,
  small
}: ButtonProps) {
  return (
    <button
      id={id}
      type={submit ? 'submit' : 'button'}
      className={classNames('button', variant, className, { disabled }, { small })}
      onClick={onClick}
      disabled={disabled}
      style={fullWidth ? { ...styles, width: '100%' } : styles}
    >
      {children}
    </button>
  )
}

export default Button
